import { useQuery } from "react-query";
import { requestApiPost } from ".";
import { GET_LEADERBOARD_DETAILS } from "../appConstants/APIEndpoint";
import _isEmpty from "lodash/isEmpty";
import { useTokenStore } from "../storage/tokenState";

const getLeaderboardDetails = async (payloadData: any, userToken: any) => {
    const { gameName = "ludonx", ltid, OffsetToken } = payloadData;
    const { accessToken } = userToken;

    const payload = {
        gameName,
        ltid,
        OffsetToken,
    };

    try {
        const res = await requestApiPost(GET_LEADERBOARD_DETAILS, payload, {
            headers: { Authorization: accessToken },
        });
        const response = res?.response;

        if (response?.success) {
            return response;
        } else {
            console.log("Failed to get Leaderboard details API");
        }
    } catch (error) {
        console.error("Error fetching leaderboard details:", error);
        // throw error;
    }
};

export const useLeaderboardDetailsApi = (payloadData: any) => {
    const { token: userToken } = useTokenStore();
    const { data = {}, isLoading, error, refetch } = useQuery({
        queryKey: ["getLeaderboardDetails", payloadData],
        queryFn: () => getLeaderboardDetails(payloadData, userToken),
        enabled: !_isEmpty(payloadData) && !_isEmpty(userToken),
    });

    return {
        leaderboardConfig: data,
        isLoading,
        error,
        refetch,
    };
};
